export default function Error404() {
  return (
    <p>La ressource que vous recherchez est introuvable</p>
  )
}
